import { newProperty } from "../schema.generator";

const attributeGlobalSchema = [
  { ...newProperty("name", "string", true, "Name") }
];

export default attributeGlobalSchema;
